import { TopicElement } from "shared/types";

import { Sheet } from "features/media/components/atoms/Sheet";
import Dot from "features/media/components/atoms/Dot";

interface Props {
  data: TopicElement;
}

export default function TableOfContents({ data }: Props) {
  const items = data.text.split("\n");

  return (
    <Sheet>
      <h3 tw="font-base text-base tracking-[.47px] leading-7">目次</h3>
      <ol tw="list-none">
        {items.map((item, index) => (
          <div key={index} tw="flex items-center">
            <Dot />
            <li tw="font-base text-xs tracking-[.35px] leading-7 underline">
              <a href={`#${item}`}>{item}</a>
            </li>
          </div>
        ))}
      </ol>
    </Sheet>
  );
}
